/**
 * GraphQL query for fetching IA Corner content (reels).
 * Defines the query structure to retrieve reels data for an IA Corner,
 * including media sections, shows, and pagination information.
 */

import { gql } from '@apollo/client';

/*******************/
/**     QUERY     **/
/*******************/

/**
 * GraphQL query string for fetching IA Corner reels.
 * Retrieves paginated reel data including media sections and associated shows.
 *
 * @param query Query params including device, corner identifier, language, carrier and plan
 * @param horizontalParams Horizontal pagination parameters
 * @param verticalParams Vertical pagination parameters
 *
 * IACorner reels query
 */
const reels = `reels(
  query: $query,
  horizontalParams: $horizontalParams,
  verticalParams: $verticalParams
) {
    results {
      mediaSection {
        limit
        name
        presentationType
        title
        titles {
          ca
          de
          en
          es
          fr
          it
        }
      }  
      shows {
        _id
        ageCode
        beginTime              
        channel
        catchup
        category
        countries
        duration
        endBookmark
        endTime
        episodeTitle
        eventId
        gender {
          name
          titles {
            en
            es
            ca
          }
        }
        kind
        moviePictures {
          background
          backgroundSrc
          photo
          photoSrc
          poster
          posterSrc
        }
        programId        
        score
        startBookmark
        synopsis
        title
        titleOriginal
        totalEpisode
        type
        url
        year
      }
      totalItems
      totalPages
    }
}`;

/**
 * GraphQL query string for fetching IA Corner reels.
 *
 * @param query Query params including device, corner identifier, language, carrier and plan
 * @param horizontalParams Horizontal pagination parameters
 * @param verticalParams Vertical pagination parameters
 * @returns IACorners GraphQL query
 */
const query = gql`
  query SectionQuery(
    $query: QuerySection!
    $horizontalParams: QueryParams!
    $verticalParams: QueryParams!
  ) {
    ${reels}
  }
`;

export default query;
